// src/data/gyms/Athletix.js
export const Athletix = {
  id: "athletix",
  name: "Athletix United",
  color: "#22C55E", // Fresh Green
  lightColor: "#DCFCE7",
  logo: "🔥",

  teams: [
    {
      id: "spitfires",
      name: "Spitfires",
      level: "L3 Junior - Flex - D2",
    },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "11:53 AM", // Floor compete
      teamId: "spitfires",
      meet: "11:17 AM", // Check-in
      panel: "Hall A",
    },

    // ================= SUNDAY (Dec 14) =================
    {
      day: "Sunday",
      time: "9:56 AM",
      teamId: "spitfires",
      meet: "9:20 AM",
      panel: "Hall A",
    },
  ],
};
